import cx from 'classnames';
import { BigButton } from '../../common';
import ActionLink from './ActionLink';
import styles from './TitleAndLinkWrapper.module.scss';
import { icons } from '../../assets';
import Button from '../../components/Button';
const { ArrowDownIcon } = icons;

function TitleAndLinkWrapper({
  style,
  titleAndLinkStyle,
  title,
  description,
  frameStyle,
  actions,
  buttonText,
  btnClassName,
  btnColor = 'primary',
  onClick,
  cancelTag,
  productUsageViewTitle = '',
  productUsageViewbuttonClick = () => {},
  onToggle = () => {},
  makeItExpandable = false,
  isOpen = false,
  dropdownInput = null,
  disabledBuyButton = null,
  cardV2 = null,
  classNameCTA= "d-flex align-items-center",
  btnLoading,
  btnStyle,
  searchComponent,
}) {
  const isToggleActive = makeItExpandable && onToggle;
  const containerStyle = {
    ...style,
    ...(isToggleActive && { cursor: 'pointer' }),
  };
  return (
    <div
      className={styles.container}
      style={containerStyle}
      {...(isToggleActive && { onClick: () => onToggle(!isOpen) })}>
      <div className={styles.innerContainer} style={titleAndLinkStyle}>
        <div className={styles.group}>
          {cardV2 ? (
            <div className={styles.info}>
              {description && (
                <p className={cx(styles.description, 'mb-0')}>
                  {description}
                  {cancelTag ? cancelTag : ''}
                </p>
              )}
              <div className={`${styles.title} align-items-center mb-4`}>{title}</div>
            </div>
          ) : (
            <div className={styles.info}>
              <div className={styles.title}>{title} {searchComponent && <span>{searchComponent}</span>}</div>
              {description && (
                <p className={cx(styles.description, 'mb-0')}>
                  {description}
                  {cancelTag ? cancelTag : ''}
                </p>
              )}
            </div>
          )}
          <div className={classNameCTA} style={{ gap: 12 }}>
            {productUsageViewTitle && (
              <ActionLink title={productUsageViewTitle} onClick={productUsageViewbuttonClick} />
            )}
            {actions}
            {dropdownInput}
            {buttonText && onClick && (
              <Button
                color={btnColor}
                size="lg"
                style={btnStyle || {}}
                className={btnClassName} // `bigButton lf-btn-1 btn-v2 ${btnClassName}`}
                // buttonTitle={buttonText}
                onClick={onClick}
                loading={btnLoading}
                disabled={disabledBuyButton}>
                {buttonText}
              </Button>
            )}
            {isToggleActive && (
              <ArrowDownIcon style={isOpen ? { transform: 'rotate(-180deg)' } : {}} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TitleAndLinkWrapper;
